/**
 * T214: tempo decorrido em texto legível.
 *
 * Antes a tela mostrava só minutos: pedido do dia 11 aparecia como
 * "⏱️ 14335 min" (e "há 238h55"). Acima de uma hora passa a valer
 * hora/dia — quem olha a fila entende "3 h" ou "10 dias" na hora.
 */
export function tempoDecorrido(criadoEm: string | Date, agora: number = Date.now()): string {
  const ms = Math.max(0, agora - new Date(criadoEm).getTime());
  const minutos = Math.floor(ms / 60000);

  if (minutos < 60) return `${minutos} min`;

  const horas = Math.floor(minutos / 60);
  if (horas < 24) return `${horas} h`;

  const dias = Math.floor(horas / 24);
  return dias === 1 ? '1 dia' : `${dias} dias`;
}